<template>
  <div class="cert-marks" :class="`cert-marks-${size}`">
    <p v-if="label" class="cert-marks-label">{{ label }}</p>

    <div class="cert-marks-row">
      <span v-for="mark in marks" :key="mark.alt" class="cert-mark">
        <img :src="mark.src" :alt="mark.alt" loading="lazy" />
      </span>
    </div>
  </div>
</template>

<script>
import bizsafeStar from "@/assets/bizsafestar.jpg";
import isoBizsafe from "@/assets/iso_bizasafe.jpg";

export default {
  name: "CertificationMarks",

  props: {
    label: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "md",
    },
  },

  data() {
    return {
      marks: [
        {
          src: bizsafeStar,
          alt: "bizSAFE Star certified",
        },
        {
          src: isoBizsafe,
          alt: "SOCOTEC ISO 45001 — SAC Accredited Certification Body OSH-2008-01",
        },
      ],
    };
  },
};
</script>

<style scoped>
.cert-marks-label {
  margin: 0 0 14px;
  color: var(--muted-light);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.cert-marks-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
}

.cert-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 18px;
  border: 1px solid var(--line);
  background: #ffffff;
}

.cert-mark img {
  width: auto;
  height: 54px;
  max-width: 100%;
  object-fit: contain;
}

.cert-marks-sm .cert-mark {
  padding: 9px 12px;
}

.cert-marks-sm .cert-mark img {
  height: 38px;
}

@media (max-width: 760px) {
  .cert-mark img {
    height: 44px;
  }

  .cert-marks-sm .cert-mark img {
    height: 34px;
  }
}
</style>
